import { render, staticRenderFns } from "./MaterialRequester.vue?vue&type=template&id=e66e1712&scoped=true"
import script from "./MaterialRequester.vue?vue&type=script&lang=js"
export * from "./MaterialRequester.vue?vue&type=script&lang=js"
import style0 from "./MaterialRequester.vue?vue&type=style&index=0&id=e66e1712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66e1712",
  null
  
)

export default component.exports